import { Map } from 'immutable';
import { AUTH_KEY } from './localStorageKeys.const';
import { getCurrentCountryContext } from './countriesHelpers';
import { getCurrentTimezone } from './dateTime';

export function clearAuthData() {
  localStorage.removeItem(AUTH_KEY);
}

interface AuthData {
  [key: string]: any;
  time_zone: string;
  id: string;
  countries: { id: string; name: string }[];
  role: string;
  username: string;
  intercom: {
    hmac: string;
  };
  profile: {
    avatar_url: string;
    email: string;
    last_name: string;
    name: string;
  };
  selectedCountry: any;
}

export function getAuthData(data?: AuthData): AuthData | null {
  try {
    let authData: AuthData | null = null;
    const auth: AuthData | null = data || JSON.parse(localStorage.getItem(AUTH_KEY) as string);
    const selectedCountryContext: any = getCurrentCountryContext();
    const selectedTimezone: string = getCurrentTimezone();

    if (auth) {
      const { state: _state, selectedCountry: _selectedCountry, ...restAuthDataProps } = auth;
      authData = { ...restAuthDataProps, time_zone: selectedTimezone, selectedCountry: selectedCountryContext };
    }

    return authData;
  } catch (err) {
    clearAuthData();

    // @ts-ignore
    return new Map();
  }
}

interface SetLocalStorageAuthDataInput {
  [key: string]: any;
}

export function setLocalStorageAuthData(data: SetLocalStorageAuthDataInput): void {
  localStorage.setItem(AUTH_KEY, JSON.stringify(data));
}
